export default "__VITE_ASSET__beef558f__"